import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  template: `
    @if (loadingService.loading()) {
      <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-maersk-mask">
        <div class="w-12 h-12 border-4 border-maersk-accent border-t-transparent rounded-full animate-spin"></div>
      </div>
    }
  `,
})
export class LoadingComponent {
  readonly loadingService = inject(LoadingService);
}
